import { Injectable, Inject } from '@angular/core';
import { Location } from '@angular/common';
import { MatSnackBar } from '@angular/material';
import { API_BASE_URL } from '../config.service';

@Injectable({
  providedIn: 'root'
})
export class CoreService {

  appRoot = '';
  appToken = 'auth';
  tokenName = 'pgiToken';


  constructor(private location: Location, public snackBar: MatSnackBar, @Inject(API_BASE_URL) public baseUrl?: string) {
    this.appRoot = baseUrl; // myenvironment.apiUrl;
    console.log('get app : ' + this.appRoot);
   }

  goBack(): void {
    this.location.back();
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: 'top',
    });
  }
}
